<template>
  <div
    :class="['button', 'button--' + variant]"
    :style="{ backgroundColor: hovering ? highlightBackgroundColor : backgroundColor }"
    @mouseover="hovering = true"
    @mouseout="hovering = false"
  >
    <div
      :class="['button__icon', 'button__icon--' + size]"
      :style="cssStyle"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md',
      validator (values) {
        return ['md', 'lg', 'xl'].includes(values)
      }
    },
    variant: {
      type: String,
      default: 'box'
    },
    color: {
      type: String,
      default: 'rgba(255, 255, 255, 0.7)'
    },
    highlightColor: {
      type: String,
      default: 'rgba(255, 255, 255, 1)'
    },
    backgroundColor: {
      type: String,
      default: 'rgb(27, 30, 33)'
    },
    highlightBackgroundColor: {
      type: String,
      default: 'rgba(39,43,47,1)'
    }
  },
  data () {
    return {
      hovering: false
    }
  },
  computed: {
    cssStyle () {
      return { 'fill': this.hovering ? this.highlightColor : this.color }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.button {
  padding: 9px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  user-select: none;

  &--box {
    border-radius: 4px;
  }

  &--round {
    border-radius: 999px;
  }

  &:hover {
    background-color: lighten($bg-2, 10);

    .button__icon {
      transform: scale(1.2);
      //fill: $blue;
    }
  }

  &:focus, &:active {
    background-color: $bg-1;

    .button__icon {
      transition: transform 0.05s ease-out;
      transform: scale(0.9);
    }
  }

  &__icon {
    transition: all 0.2s ease-out;

    &--md {
      width: 14px;
      height: 14px;
      line-height: 14px;

      @media screen and (min-width: $breakpointLg) {
        width: 16px;
        height: 16px;
        line-height: 16px;
      }
    }

    &--lg {
      width: 18px;
      height: 18px;
      line-height: 18px;

      @media screen and (min-width: $breakpointLg) {
        width: 20px;
        height: 20px;
        line-height: 20px;
      }
    }

    &--xl {
      width: 22px;
      height: 22px;
      line-height: 22px;

      @media screen and (min-width: $breakpointLg) {
        width: 24px;
        height: 24px;
        line-height: 24px;
      }
    }
  }
}
</style>
